import type { PaymentMethod } from "@jti/fe-common";

import type { PaymentOption } from "../../components/PaymentMethodsSection";

export const mapMethodsToPaymentOptions = (methods: ReadonlyArray<PaymentMethod>): PaymentOption[] =>
  methods.map(({ enabled, ...rest }) => ({
    ...rest,
    disabled: !enabled,
  }));
